import type { RouteObject } from 'react-router-dom';

/**
 * Coder feature routes (design §5.1) — a registry-compatible placeholder:
 * P5 ships no coder routes of its own (the wizard steps mount through the
 * agents wizard-step glob; the boards mount into the project detail page).
 * This module exists so any future coder route lands without shell edits —
 * the same pattern as `features/roles` in P1 §5.3. No `nav.ts` is contributed
 * (G3: no standalone coder navigation).
 */
export const routes: RouteObject[] = [];
